import { action } from 'satcheljs';

export const getSubscriberType = action('getSubscriberType');
